import React from "react";
import Carousel from "../../Components/Carousel/Carousel";

const LlaimaCarousel = (props) => {
    return <Carousel id="games"/>;
};

export default LlaimaCarousel;
